export default __webpack_public_path__ + "static/media/modal-proprietarios-araucaria-image.0bf886a9.webp";